<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.go(-1)">
                <van-icon name="arrow-left"/>
            </div>
            <div class="big_tit">{{ $t('lang.个人设置') }}</div>
        </div>
        <div class="wrap_box">
            <div class="card">
                <router-link to="/language" class="item">
                    <div class="left">
                        <span class="icon icon_login"></span>
                        <span class="info">{{ $t('lang.语言') }}</span>
                    </div>
                    <div class="right icon_right">
                        <van-icon name="arrow"/>
                    </div>
                </router-link>
                <!--            <div class="line"></div>-->
                <!--            <router-link to="/language" class="item">-->
                <!--                <div class="left">-->
                <!--                    <span class="icon icon_login"></span>-->
                <!--                    <span class="info">{{ $t('lang.编辑个人信息') }}</span>-->
                <!--                </div>-->
                <!--                <div class="right icon_right"><van-icon name="arrow" /></div>-->
                <!--            </router-link>-->
                <div class="line"></div>
                <!--            <router-link to="/setpwd" class="item">-->
                <router-link to="/kefu" class="item">
                    <div class="left">
                        <span class="icon icon_login"></span>
                        <span class="info">{{ $t('safe.signInPassword') }}</span>
                    </div>
                    <div class="right icon_right">
                        <van-icon name="arrow"/>
                    </div>
                </router-link>
                <div class="line"></div>
                <!--            <router-link to="/setpaypwd" class="item">-->
                <router-link to="/kefu" class="item">
                    <div class="left">
                        <span class="icon icon_pay"></span>
                        <span class="info">{{ $t('safe.paymentPassword') }}</span>
                    </div>
                    <div class="right icon_right">
                        <van-icon name="arrow"/>
                    </div>
                </router-link>
                <router-link to="/about/12" class="item">
                    <div class="left">
                        <span class="icon icon_greement"></span>
                        <span class="info">{{ $t('index.agreement') }}</span>
                    </div>
                    <div class="right icon_right">
                        <van-icon name="arrow"/>
                    </div>
                </router-link>
                <div class="line"></div>
                <router-link to="/about/13" class="item">
                    <div class="left">
                        <span class="icon icon_policy"></span>
                        <span class="info">{{ $t('index.secret') }}</span>
                    </div>
                    <div class="right icon_right">
                        <van-icon name="arrow"/>
                    </div>
                </router-link>


                <!--            <router-link to="/realName" class="item">-->
                <!--                <div class="left">-->
                <!--                    <span class="icon icon_login"></span>-->
                <!--                    <span class="info">{{ $t('userSet.sm') }}</span>-->
                <!--                </div>-->
                <!--                <div class="right icon_right"><van-icon name="arrow" /></div>-->
                <!--            </router-link>-->
                            <div class="line"></div>
                            <router-link to="/account" class="item">
                                <div class="left">
                                    <span class="icon icon_login"></span>
                                    <span class="info">{{ $t('safe.paymentOptions') }}</span>
                                </div>
                                <div class="right icon_right"><van-icon name="arrow" /></div>
                            </router-link>
                <!--            <div class="line"></div>-->
                <!--            &lt;!&ndash; <router-link to="/language" class="item">-->
                <!--                <div class="left">-->
                <!--                    <span class="icon icon_login"></span>-->
                <!--                    <span class="info">{{$t('safe.language')}}</span>-->
                <!--                </div>-->
                <!--                <div class="right icon_right"></div>-->
                <!--            </router-link> &ndash;&gt;-->
                <!--            <router-link to="/setpwd" class="item">-->
                <!--                <div class="left">-->
                <!--                    <span class="icon icon_login"></span>-->
                <!--                    <span class="info">{{ $t('safe.signInPassword') }}</span>-->
                <!--                </div>-->
                <!--                <div class="right icon_right"><van-icon name="arrow" /></div>-->
                <!--            </router-link>-->
                <!--            <div class="line"></div>-->
                <!--            <router-link to="/setpaypwd" class="item">-->
                <!--                <div class="left">-->
                <!--                    <span class="icon icon_pay"></span>-->
                <!--                    <span class="info">{{ $t('safe.paymentPassword') }}</span>-->
                <!--                </div>-->
                <!--                <div class="right icon_right"><van-icon name="arrow" /></div>-->
                <!--            </router-link>-->
                <!--            <div class="line"></div>-->
                <!--            <router-link to="/about/12" class="item">-->
                <!--                <div class="left">-->
                <!--                    <span class="icon icon_greement"></span>-->
                <!--                    <span class="info">{{ $t('index.agreement') }}</span>-->
                <!--                </div>-->
                <!--                <div class="right icon_right"><van-icon name="arrow" /></div>-->
                <!--            </router-link>-->
                <!--            <div class="line"></div>-->
                <!--            <router-link to="/about/13" class="item">-->
                <!--                <div class="left">-->
                <!--                    <span class="icon icon_policy"></span>-->
                <!--                    <span class="info">{{ $t('index.secret') }}</span>-->
                <!--                </div>-->
                <!--                <div class="right icon_right"><van-icon name="arrow" /></div>-->
                <!--            </router-link>-->

            </div>
            <div class="history_coupon" @click="logout">
                <span>{{ $t('safe.signOut') }}</span>
            </div>
        </div>


    </div>
</template>

<script>
import Fetch from '../../utils/fetch'
import bsHeader from '../../components/bsHeader.vue'

export default {
    name: "safe",
    components: {
        bsHeader
    },
    data() {
        return {
            data: {},
            appVer: "",
            wgtVer: "",
        };
    },
    created() {
        this.$parent.footer('user', false);
    },
    mounted() {
        this.start();
        this.getVersion();
    },
    methods: {
        start() {
            Fetch('/user/info').then((r) => {
                this.data = r.data;
            });
        },
        logout() {
            localStorage.removeItem('token');
            this.$router.replace("/");
        },
    }
};
</script>

<style lang="less" scoped>
.red_top_bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgb(35, 29, 29) !important;
  color: rgb(239, 216, 196) !important;

  .back_left {
    color: rgb(239, 216, 196) !important;
  }

  .big_tit {
    color: rgb(239, 216, 196) !important;
  }
}

.basic_wrap {
  height: 100vh;
}

.line {
  width: 100%;
  height: 0.03125rem;
  border: 0.0625rem solid #474142;
  margin: 0 auto;
}

.wrap_box {
  margin-top: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url('../../assets/img/home-bg.jpg') repeat center;
  background-size: 100%;
  height: calc(100vh - 46px);
  box-shadow: none !important;
  border-radius: 0 !important;
  padding: 20px;

  .card {
    width: 100%;
    background: #251E1F;
    border: 1px solid #917E70;
    border-radius: 0.59375rem;
    margin: 0 auto;
    margin-top: 1.25rem;
  }

  .item {
    height: 50px;
    width: 95%;
    margin: 0 auto;
    padding: 16px 0;
    font-size: .78125rem;
    color: #feecd6;
    opacity: .7;
    flex: 1;
    line-height: 20px;
    display: flex;
    justify-content: space-between;

    .right_info {

    }

    .tips {
      margin-left: auto;
      margin-right: 4px;
    }
  }
}

.history_coupon {
  width: 15.15625rem;
  height: 2.40625rem;
  background: #4D4241;
  border-radius: 0.40625rem;
  line-height: 2.40625rem;
  text-align: center;
  font-size: .84375rem;
  color: #ff5a5a;
  position: fixed;
  bottom: 1.875rem;
}

.flex_center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.auth {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
